import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";

const navLinks = [
  { name: "Home", path: "/" },
  { name: "About Bikram", path: "/about" },
  { name: "The Work", path: "/the-work" },
  { name: "Watch & Read", path: "/watch-read" },
  { name: "Dialogue", path: "/dialogue" },
  { name: "Events", path: "/events" },
  { name: "Contact", path: "/contact" },
];

export function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header
      className="sticky top-0 z-50 backdrop-blur-md border-b border-[hsl(48,12%,88%)]"
      style={{ backgroundColor: "hsla(48, 45%, 98%, 0.85)" }}
      data-testid="navbar"
    >
      <nav className="max-w-screen-xl mx-auto px-6 md:px-12 lg:px-24 flex items-center justify-between h-16 md:h-20">
        <Link
          to="/"
          className="font-accent italic text-2xl md:text-3xl tracking-tight text-foreground"
          data-testid="nav-logo"
        >
          Bikram Jha
        </Link>

        <div className="hidden lg:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              data-testid={`nav-link-${link.path.replace("/", "") || "home"}`}
              className={`font-body text-sm tracking-wide transition-colors duration-300 ${
                location.pathname === link.path
                  ? "text-foreground"
                  : "text-muted-foreground hover:text-foreground"
              }`}
            >
              {link.name}
            </Link>
          ))}
        </div>

        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger className="lg:hidden" data-testid="mobile-menu-trigger">
            <Menu size={24} strokeWidth={1.5} />
          </SheetTrigger>
          <SheetContent
            side="right"
            className="w-full max-w-sm border-l border-[hsl(48,12%,88%)]"
            style={{ backgroundColor: "#FDFCF8" }}
          >
            <div className="flex flex-col gap-8 mt-16 px-4">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setOpen(false)}
                  data-testid={`mobile-nav-link-${link.path.replace("/", "") || "home"}`}
                  className="font-heading text-3xl tracking-tight text-foreground transition-opacity hover:opacity-70"
                >
                  {link.name}
                </Link>
              ))}
            </div>
          </SheetContent>
        </Sheet>
      </nav>
    </header>
  );
}
